export enum UsersGroup {
  Staff = 1,
  Agents = 2,
  Brokers = 3,
  Producers = 4,
  Dealers = 5,
  RepairFacilities = 6,
  ServiceAdvisors = 7,
  Admins = 9,
  ClaimsAdjusters = 10,
  Lienholders = 14,
  DealerGroups = 25,
  AdminCompany = 'AdminCompany',
  Insurers = 'Insurer',
  Salespeople = 'Salesperson',
  Vendors = 'Vendor',
}
